"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.request = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _logUtil = require("./logUtil");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
/* Intercept all request to ensure headers are correct */
/* Wraps axios with additional app-specific features/data points */
var _config = /*#__PURE__*/new WeakMap();
class request {
  constructor(endpoint) {
    _classPrivateFieldInitSpec(this, _config, {
      writable: true,
      value: require("../indi.config.json")
    });
    _defineProperty(this, "endpointURL", "");
    this.endpointURL = _classPrivateFieldGet(this, _config).apiURL + endpoint.trim();
    _axios.default.interceptors.request.use(config => {
      document.body.classList.add('data-loading');
      const {
        origin
      } = new URL(config.url);
      const allowedOrigins = [_classPrivateFieldGet(this, _config).apiURL];
      if (allowedOrigins.includes(origin)) {
        const token = localStorage.getItem('token');
        const tenantid = localStorage.getItem('tenantid');

        /* Apply x-caller header key to each request to keep track of session/tenant information */
        let oldHeaders = Object.assign({
          "X-Caller": window.location.hostname
        }, config.headers);
        config.headers = oldHeaders;
        if (token) {
          let oldHeaders = Object.assign({
            Authorization: "Bearer " + token
          }, config.headers);
          config.headers = oldHeaders;
        }
        if (tenantid) {
          let oldHeaders = Object.assign({
            "X-Tenant": tenantid
          }, config.headers);
          config.headers = oldHeaders;
        }
      }
      return config;
    }, this.handleError);

    /* Add intercepter to every response to check for JWT expiration and error handling */
    _axios.default.interceptors.response.use(response => {
      document.body.classList.remove('data-loading');
      return response;
    }, error => {
      document.body.classList.remove('data-loading');
      if (error.response) {
        const data = error.response.data;
        if (data.cause && data.cause.includes("JWT expired")) {
          _logUtil.logger.info("Token has expired; attempting to refresh.");
          _axios.default.get(_classPrivateFieldGet(this, _config).apiURL + "/refreshtoken", {
            headers: {
              "isRefreshToken": true
            }
          }).then(response => {
            if (response.data && response.data.token) {
              /* Set new token */
              _logUtil.logger.info("Token refreshed.");
              localStorage.setItem("token", response.data.token);

              /* TODO: Since we refreshed out token, we should attempt the request again or set flag and letconsumer do that? */
            }
            return response.data;
          }).catch(error => {
            _logUtil.logger.error("Error during token refresh with error: " + error);
            let errorObj = Object.assign({
              isError: true
            }, error);
            return errorObj;
          });
        } else {
          /* Most likely a real error. consume and process here */
          return data;
        }
      } else {
        /* Most likely a real error. consume and process here */
        return error;
      }
    });
  }
  handleError(error, logMessage) {
    _logUtil.logger.error(logMessage);
    let errorObj = Object.assign({
      isError: true,
      message: logMessage
    }, error);
    return Promise.resolve(errorObj);
  }
  handleSuccess(data) {
    return Promise.resolve(data);
  }
  /* Returns a promise (from the function and then()/catch() methods)  */
  get() {
    _logUtil.logger.debug("Calling GET: " + this.endpointURL);
    return _axios.default.get(this.endpointURL).catch(function (error) {
      return this.handleError(error, "Error during fetch to: " + this.endpointURL + " with error: " + error);
    });
  }
  /* Returns a promise (from the function and then()/catch() methods)  */
  async post(body) {
    _logUtil.logger.debug("Calling POST: " + this.endpointURL);
    const errorMessage = "Error during post to: " + this.endpointURL + " with error data: ";
    return _axios.default.post(this.endpointURL, body).then(response => {
      if (response.status === undefined) {
        return this.handleError(response, errorMessage + JSON.stringify(response));
      }
      return this.handleSuccess(response.data);
    }).catch(error => {
      return this.handleError(error, errorMessage + error);
    });
  }
}
exports.request = request;
;